import SEOHead from "@/components/General/SEOHead";
import ServiceDetail from "@/modules/Services/ServiceDetail";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { fetchPageContent } from "@/lib/server-content";
import { jsonBody } from "@/lib/seo";
export default function ServiceDetailPage() {
  return (
    <div className="bg-white py-4">
      <SEOHead />
      <ServiceDetail />
    </div>
  );
}
export async function getServerSideProps({ locale = "ar", params }: any) {
  const services = await fetchPageContent("Services", locale);
  if (!jsonBody(services).services?.some((s: any) => s.slug === params.slug))
    return { notFound: true };
  return { props: { ...(await serverSideTranslations(locale, ["common"])) } };
}
